import classNames from 'classnames';
import { SectionTitle, type SectionTitleProps } from './SectionTitle';

export interface SectionProps
  extends Pick<SectionTitleProps, 'title' | 'iconType' | 'tooltipContent'> {
  children: React.ReactNode;
  overflowHidden?: boolean;
}

export const Section = ({
  title,
  iconType,
  tooltipContent,
  children,
  overflowHidden,
}: SectionProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col flex-1 gap-4 pt-5 pb-5 min-h-0',
        overflowHidden && 'overflow-hidden'
      )}
    >
      <SectionTitle
        title={title}
        iconType={iconType}
        tooltipContent={tooltipContent}
      />
      {children}
    </div>
  );
};
